import React, { useState, forwardRef, useImperativeHandle } from 'react';

import { InputAdornment } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Visibility from '@material-ui/icons/Visibility';
import { useSnackbar } from 'notistack';

import {
  TextInput,
  PrecoInput,
  AutoCompleteRemoto,
  DateInputBonito,
} from '../../../Components';
import {
  createAPI,
  updateAPI,
  getListAllAPI,
  api,
  getUserId,
} from '../../../services';
import { STATUS_ATIVO } from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DEFAULT_ID = -1;

const DialogoCategoriaTransacao = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [descricao, setDescricao] = useState('');
  const [valor, setValor] = useState(0);
  const [data, setData] = useState(new Date());

  const [categoria, setCategoria] = useState(null);
  const [id, setId] = useState(DEFAULT_ID);

  const [user, setUser] = useState(null);
  const [senha, setSenha] = useState('');
  const [gerenteUser, setGerenteUser] = useState(null);
  const [senhaGerenteUser, setSenhaGerenteUser] = useState('');
  const [testemunhaUser, setTestemunhaUser] = useState(null);
  const [senhaTestemunhaUser, setSenhaTestemunhaUser] = useState('');

  const [carregando, setCarregando] = useState(false);

  const classes = useStyles({ cor: '#009FD4' });

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  async function getUser() {
    const response = await api.get(`/users/${getUserId()}`);
    return response.data;
  }

  async function reiniciar() {
    setId(DEFAULT_ID);
    setDescricao('');
    setValor(0);
    setData(new Date());
    setCategoria(null);
    setCarregando(false);
    setUser(null);
    setSenha('');
    setGerenteUser(await getUser());
    setSenhaGerenteUser('');
    setTestemunhaUser(null);
    setSenhaTestemunhaUser('');
  }

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'descontos_funcionarios',
        ['id', 'asc'],
        { id: [id] },
        ['user', 'categoria'],
      );
      if (data.data.length > 0) {
        setId(data.data[0].id);
        setDescricao(data.data[0].descricao);
        setValor(data.data[0].valor);
        setData(data.data[0].data);
        setUser(data.data[0].user);
        setCategoria(data.data[0].categoria);
        setCarregando(false);
        setSenha('');
        setGerenteUser(null);
        setSenhaGerenteUser('');
        setTestemunhaUser(null);
        setSenhaTestemunhaUser('');
      } else {
        throw 'Este Desconto de funcionário não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleCreate() {
      reiniciar();
      setOpen(true);
    },
    handleEdit(id) {
      //setCarregando(true);
      getDataResource(id);
      setId(id);
      setOpen(true);
    },
  }));

  function validateDescricao() {
    let error = '';
    if (descricao) {
      if (descricao.length > 300) {
        error = 'Número de caracteres maior que o permitido (máximo 80)';
      }
    }
    return error;
  }

  function validateValor() {
    let error = '';
    if (valor <= 0 || Number.isNaN(valor)) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  function validateUser() {
    let error = '';
    if (!user) {
      error = 'Este campo é obrigatório';
    } else if (gerenteUser) {
      if (user.id === gerenteUser.id) {
        error =
          'O operador de caixa não pode ser também o gerente neste registro!';
      } else if (testemunhaUser) {
        if (user.id === testemunhaUser.id) {
          error =
            'O operador de caixa não pode ser também a testemunha neste registro!';
        }
      }
    }
    return error;
  }

  function validateCategoria() {
    let error = '';
    if (!categoria) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  function validateGerenteUser() {
    let error = '';
    if (!gerenteUser) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  function validateTestemunhaUser() {
    let error = '';
    if (!testemunhaUser) {
      error = 'Este campo é obrigatório';
    } else if (gerenteUser) {
      if (testemunhaUser.id === gerenteUser.id) {
        error = 'A testemunha não pode ser também o gerente neste registro!';
      }
    }
    return error;
  }

  function validateSenhaUser() {
    let error = '';
    if (!senha) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  function validateSenhaGerenteUser() {
    let error = '';
    if (!senhaGerenteUser) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  function validateSenhaTestemunhaUser() {
    let error = '';
    if (!senhaTestemunhaUser) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  function getErros() {
    const errosOld = [''];
    errosOld[0] = validateDescricao();
    errosOld[1] = validateValor();
    errosOld[2] = validateUser();
    errosOld[3] = validateCategoria();
    errosOld[4] = validateGerenteUser();
    errosOld[5] = validateTestemunhaUser();
    errosOld[6] = validateSenhaUser();
    errosOld[7] = validateSenhaGerenteUser();
    errosOld[8] = validateSenhaTestemunhaUser();
    return errosOld;
  }

  const erros = getErros();

  function hasError() {
    for (let i = 0; i < erros.length; i += 1) {
      if (erros[i] !== '') return true;
    }
    return false;
  }

  const erroExistente = hasError();

  async function handleSalvarDialog() {
    if (!erroExistente) {
      try {
        //setCarregando(true);

        let response = await api.post('/login_retirada_caixa', {
          username: user.username,
          password: senha,
        });

        if (!response.data.status)
          throw `Operador de Caixa, ${response.data.message}`;

        response = await api.post('/login_retirada_caixa', {
          username: gerenteUser.username,
          password: senhaGerenteUser,
        });

        if (!response.data.status) throw `Gerente, ${response.data.message}`;

        response = await api.post('/login_retirada_caixa', {
          username: testemunhaUser.username,
          password: senhaTestemunhaUser,
        });

        if (!response.data.status) throw `Testemunha, ${response.data.message}`;

        if (id <= 0) {
          await createAPI('descontos_funcionarios', {
            descricao,
            valor,
            data,
            user_id: user.id,
            categoria_desconto_funcionario_id: categoria.id,
            gerente_user_id: gerenteUser.id,
            testemunha_user_id: testemunhaUser.id,
          });
          //setCarregando(false);
          enqueueSnackbar('Desconto de funcionário criado com sucesso!', {
            variant: 'success',
          });
        } else {
          await updateAPI('descontos_funcionarios', id, {
            descricao,
            valor,
            data,
            user_id: user.id,
            categoria_desconto_funcionario_id: categoria.id,
            gerente_user_id: gerenteUser.id,
            testemunha_user_id: testemunhaUser.id,
          });
          //setCarregando(false);
          enqueueSnackbar('Desconto de funcionário atualizado com sucesso!', {
            variant: 'success',
          });
        }

        handleCloseDialog();
      } catch (e) {
        enqueueSnackbar(e, {
          variant: 'error',
        });
      } finally {
        //setCarregando(false);
      }
    }
  }

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="md"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          {id < 0
            ? `Novo Desconto de funcionário`
            : `Editar Desconto de funcionário`}
        </DialogTitle>
        <DialogContent
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          {carregando ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                marginTop: '10px',
              }}
            >
              <fieldset
                style={{
                  width: '100%',
                  display: 'flex',
                  padding: '10px',
                  borderRadius: '5px',
                }}
              >
                <legend style={{ padding: '0 10px' }}>Operador de Caixa</legend>
                <Box
                  display="flex"
                  alignItems="center"
                  flex={1}
                  style={{
                    gap: '10px',
                    display: 'flex',
                  }}
                >
                  <Box flex={1} mr="0.5em">
                    <AutoCompleteRemoto
                      name="user"
                      handleEnter={() => {}}
                      label="Usuário"
                      handleKey={() => {}}
                      value={user}
                      onChange={(value) => setUser(value)}
                      error={erros[2] !== ''}
                      helperText={erros[2]}
                      fullWidth
                      toString={false}
                      getOptionSelected={(option, value) =>
                        option.username === value.username
                      }
                      getOptionLabel={(option) => `${option.username}`}
                      nested={[]}
                      filters={{ status: STATUS_ATIVO }}
                      resource="users"
                      campo="username"
                      autoFocus
                    />
                  </Box>
                  <Box flex={1} ml="0.5em">
                    <TextInput
                      handleEnter={() => {}}
                      name="password"
                      type="password"
                      label="Senha"
                      value={senha}
                      onChange={(event) => {
                        setSenha(event.target.value);
                      }}
                      fullWidth
                      handleKey={(action, name) => {}}
                      error={erros[6] !== ''}
                      helperText={erros[6]}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                          >
                            <Visibility />
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={70}
                    />
                  </Box>
                </Box>
              </fieldset>
              <fieldset
                style={{
                  width: '100%',
                  display: 'flex',
                  //margin: '20px',
                  padding: '10px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <legend style={{ padding: '0 10px' }}>Gerente</legend>
                <Box
                  display="flex"
                  alignItems="center"
                  flex={1}
                  style={{
                    gap: '10px',
                    display: 'flex',
                  }}
                >
                  <Box flex={1} mr="0.5em">
                    <AutoCompleteRemoto
                      name="user"
                      handleEnter={() => {}}
                      label="Usuário"
                      handleKey={() => {}}
                      value={gerenteUser}
                      onChange={(value) => setGerenteUser(value)}
                      error={erros[4] !== ''}
                      helperText={erros[4]}
                      fullWidth
                      toString={false}
                      getOptionSelected={(option, value) =>
                        option.username === value.username
                      }
                      getOptionLabel={(option) => `${option.username}`}
                      nested={[]}
                      filters={{
                        status: STATUS_ATIVO /* , is_responsavel: true */,
                      }}
                      resource="users"
                      campo="username"
                      disabled
                    />
                  </Box>
                  <Box flex={1} ml="0.5em">
                    <TextInput
                      handleEnter={() => {}}
                      name="password"
                      type="password"
                      label="Senha"
                      value={senhaGerenteUser}
                      onChange={(event) => {
                        setSenhaGerenteUser(event.target.value);
                      }}
                      fullWidth
                      handleKey={(action, name) => {}}
                      error={erros[7] !== ''}
                      helperText={erros[7]}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                          >
                            <Visibility />
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={70}
                    />
                  </Box>
                </Box>
              </fieldset>
              <fieldset
                style={{
                  width: '100%',
                  display: 'flex',
                  //margin: '20px',
                  padding: '10px',
                  borderRadius: '5px',
                  flexDirection: 'column',
                }}
              >
                <legend style={{ padding: '0 10px' }}>Testemunha</legend>
                <Box
                  display="flex"
                  alignItems="center"
                  flex={1}
                  style={{
                    gap: '10px',
                    display: 'flex',
                  }}
                >
                  <Box flex={1} mr="0.5em">
                    <AutoCompleteRemoto
                      name="user"
                      handleEnter={() => {}}
                      label="Usuário"
                      handleKey={() => {}}
                      value={testemunhaUser}
                      onChange={(value) => setTestemunhaUser(value)}
                      error={erros[5] !== ''}
                      helperText={erros[5]}
                      fullWidth
                      toString={false}
                      getOptionSelected={(option, value) =>
                        option.username === value.username
                      }
                      getOptionLabel={(option) => `${option.username}`}
                      nested={[]}
                      filters={{ status: STATUS_ATIVO }}
                      resource="users"
                      campo="username"
                    />
                  </Box>
                  <Box flex={1} ml="0.5em">
                    <TextInput
                      handleEnter={() => {}}
                      name="password"
                      type="password"
                      label="Senha"
                      value={senhaTestemunhaUser}
                      onChange={(event) => {
                        setSenhaTestemunhaUser(event.target.value);
                      }}
                      fullWidth
                      handleKey={(action, name) => {}}
                      error={erros[8] !== ''}
                      helperText={erros[8]}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                          >
                            <Visibility />
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={70}
                    />
                  </Box>
                </Box>
              </fieldset>
              <Box
                display="flex"
                alignItems="center"
                flex={1}
                style={{
                  gap: '10px',
                  display: 'flex',
                }}
              >
                <Box flex={1} mr="0.5em">
                  <PrecoInput
                    name="valor"
                    handleEnter={() => {}}
                    label="Valor"
                    handleKey={() => {}}
                    value={Number.isNaN(valor) ? '' : String(valor)}
                    onChange={(value) =>
                      setValor(parseFloat(value.target.value))
                    }
                    error={erros[1] !== ''}
                    helperText={erros[1]}
                    fullWidth
                  />
                </Box>
                <Box flex={1} mr="0.5em" mt="8px">
                  <DateInputBonito
                    showTodayButton
                    disableFuture
                    todayLabel="Hoje"
                    name="data_pagamento"
                    handleEnter={() => {}}
                    label="Data"
                    handleKey={() => {}}
                    value={data}
                    onChange={(value) => {
                      setData(value);
                    }}
                    format="dd MMMM yyyy"
                    fullWidth
                    inputVariant="outlined"
                  />
                </Box>
              </Box>

              <Box
                display="flex"
                alignItems="center"
                flex={1}
                style={{
                  gap: '10px',
                  display: 'flex',
                }}
              >
                <Box flex={1} mr="0.5em" mt="-20px">
                  <AutoCompleteRemoto
                    name=""
                    handleEnter={() => {}}
                    label="Categoria"
                    handleKey={() => {}}
                    value={categoria}
                    onChange={(value) => setCategoria(value)}
                    error={erros[3] !== ''}
                    helperText={erros[3]}
                    fullWidth
                    toString={false}
                    getOptionSelected={(option, value) =>
                      option.nome === value.nome
                    }
                    getOptionLabel={(option) => `${option.nome}`}
                    nested={[]}
                    filters={{}}
                    resource="categorias_descontos_funcionarios"
                  />
                </Box>
                <Box flex={1} mr="0.5em" mt="8px" />
              </Box>
            </div>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          <div className={classes.wrapper}>
            <Button
              onClick={handleSalvarDialog}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              disabled={erroExistente || carregando}
              variant="contained"
              color="primary"
            >
              Salvar
            </Button>
            {carregando && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
